import { Editor, EditorState } from "draft-js"
import React from "react"
import {
  fontColorStyleMap,
  fontSizeStyleMap,
  fontWeightSyleMap,
} from "../../../../../libs/style-map"
import styled from "styled-components"
import Color from "../../../../../../../../../style/enum/color"

const CUSTOM_STYLE_MAP = {
  ...fontWeightSyleMap,
  ...fontColorStyleMap,
  ...fontSizeStyleMap,
}

interface IProps {
  editorState: EditorState
  onChange: (editorState: EditorState) => void
  placeholder?: string
}

export const CustomStyleEditor = (props: IProps) => (
  <Editor
    customStyleMap={CUSTOM_STYLE_MAP}
    stripPastedStyles={true}
    {...props}
  />
)

export const EditorWrapper = styled.div`
  border: 1px solid ${Color.BRAND};
  border-radius: 5px;
  padding: 15px;
  margin: 10px 0;
`
